import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from './dateTimeFormats'
import numberFormats from './numberFormats'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'de', 
  fallbackLocale: 'en',
  messages: {},
  dateTimeFormats, 
  numberFormats,
  silentTranslationWarn: false // Disable no translation Warnings
})

export default i18n